import { render, staticRenderFns } from "./IncomeDetai.vue?vue&type=template&id=6af6e3c3&"
import script from "./IncomeDetai.vue?vue&type=script&lang=js&"
export * from "./IncomeDetai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports